import { UIHeading2 } from '@cian/ui-kit';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './ServicesPageHeader.css';

interface IServicesPageHeaderProps {
  returnUrl: string;
}

export const ServicesPageHeader: React.FC<IServicesPageHeaderProps> = ({ returnUrl }) => {
  return (
    <div className={styles['container']}>
      <a href={returnUrl}>
        <IconActionArrowLeft24 />
      </a>
      <UIHeading2>Сервисы</UIHeading2>
    </div>
  );
};
